import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";

export default function Home() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-xl text-center space-y-8">
        <div className="font-mono text-[14px] uppercase tracking-[0.3em] text-secondary">
          QUIZ AFFIANCO AI 5.0
        </div>
        <h1 className="text-5xl md:text-6xl text-primary font-serif leading-tight">
          La piattaforma dei test
          <br />
          <span className="text-accent">intelligenti</span>
        </h1>
        <p className="text-secondary text-[19px] leading-relaxed">
          Verifica, allena, cresci. Con nativo supporto AI.
        </p>
        <div className="flex justify-center gap-3 pt-4">
          <Link to="/accedi">
            <Button variant="primary">Accedi alla mia area →</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
